// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"47":"07f2f37c","439":"1014248b","770":"4b4ce3f6","791":"e8c63832","875":"09bbd95e","880":"f5c38f53"}[chunkId] + ".chunk.css";
};